import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  CREATE_NOTIFICATION
} from './mutations-types'
import store from '../../store'
import lodash from 'lodash'
export default {
  createNotification ({commit, state, dispatch}, { message }) {
    const selectedAdvertiserId = store.getters.getCurrentUser.firebaseAccount.selectedAdvertiser
    const advertiser = store.getters.getAdvertisers.find(a => a.id === selectedAdvertiserId)
    if (advertiser) {
      const copy = lodash.cloneDeep(advertiser)
      if (!copy.data.notifications) {
        copy.data.notifications = [message]
      } else {
        copy.data.notifications.push(message)
      }
      return new Promise(resolve => {
        resolve(dispatch('updateAdvertiser', copy))
      })
        .then(res => {
          commit(CREATE_NOTIFICATION, message)
        })
    }
  },
  showNotification ({ commit }, payload) {
    commit(SHOW_NOTIFICATION, payload)
    let timeout = setTimeout(() => {
      commit(HIDE_NOTIFICATION)
      clearTimeout(timeout)
    }, 5000)
  }
}
